import React from 'react'
import { Arrow, ArrowLinkOutSideBox } from '../Icons'
import { LinkWrap } from '@truphone/gatsby-wrappers'

export default function Featured(props) {
  const collapsed = props.collapsed || (props.value && props.options && props.options.length > 0)

  return (
    <>
      {props.articles &&
        props.articles.length > 0 &&
        props.articles.map((article, i) => (
          <LinkWrap
            key={`article-${i}`}
            href={article.href}
            target="_blank"
            className={`block svg-hover transition-all duration-300 hover:bg-blue-300 hover:text-white bg-white text-black shadow-sm p-5 rounded-2xl mt-2`}
          >
            <div className={`flex justify-between ${collapsed ? 'items-center' : ''}`}>
              <div>
                {article.title && (
                  <h3 className={`${collapsed ? 'text-sm font-semibold' : 'text-xl'}`}>
                    {article.title}
                  </h3>
                )}
                {article.subtitle && (
                  <p className={`${collapsed ? 'text-xs mt-1' : 'text-sm'}`}>{article.subtitle}</p>
                )}
              </div>
              {article.href && collapsed ? (
                <Arrow className="w-4 h-4 -rotate-90" />
              ) : (
                <ArrowLinkOutSideBox className={`text-blue-100 hover:text-current`} />
              )}
            </div>

            {article.content && !collapsed && (
              <div
                className="text-xs font-light p-margin mt-4 h-20 overflow-hidden"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
            )}
          </LinkWrap>
        ))}

      {props.options && (props.value === undefined || props.value === null) && (
        <div className="mt-4">
          {props.label && (
            <label className="mb-2 text-sm inline-block">
              {props.label} {props.required && '*'}
            </label>
          )}
          <div>
            {props.options.map((option, j) => {
              return (
                <button
                  key={`option-${j}`}
                  className={`${
                    props.value === option.value ? 'bg-black text-white' : ''
                  } border-2 border-black rounded py-2 px-6 text-sm mt-2 mb-2 mr-2 hover:bg-black hover:bg-opacity-10 active:opacity-30 active:bg-black`}
                  onClick={() => props.onChange(option.value)}
                  data-value={option.value || option.text}
                >
                  {option.text}
                </button>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}
